import {Inject, Injectable} from '@angular/core';
import {ToastController} from 'ionic-angular';

import {FirebaseApp} from "@angular/fire";
import * as firebase from 'firebase/app';
import {HttpProvider} from '../../providers/http/http';
import {HttpHeaders} from '@angular/common/http';
import 'firebase/messaging';


@Injectable()
export class NotificationWebProvider {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'key=AAAAC2yPn8o:APA91bFyNpCINk_knPCKQHuQTtPfwPtNOaIadXistwsr5OatnAVANiAF9WeFdOLTQ0a0poJQMzek4nXvpPg1Mr2ailtST23u7Aa_mQGcXhUXY-7YW0tsxeljGQ_pELlgnQIPf48twfnQ'
    })
  };


  private messaging: firebase.messaging.Messaging;
  public response = {
    notification: {
      body: ""
    }
  };


  constructor(@Inject(FirebaseApp) private _firebaseApp: firebase.app.App,
              public toastCtrl: ToastController,
              public httpProv: HttpProvider) {
    // if (firebase.messaging.isSupported()) {
    this.messaging = firebase.messaging(this._firebaseApp);
    this.messaging.usePublicVapidKey('BLjkQwG3D1MNaN8t9N4MrKVEGL-tWwfoSrR-zI3FA-GniRo0zPzc8qWMcwnw08Ox0u7G5DvFRlOsH-_Ht5Pf0tU');


    // this.messaging = firebase.messaging(this._firebaseApp);
    // this.messaging.usePublicVapidKey('BLjkQwG3D1MNaN8t9N4MrKVEGL-tWwfoSrR-zI3FA-GniRo0zPzc8qWMcwnw08Ox0u7G5DvFRlOsH-_Ht5Pf0tU');
    /*
        navigator.serviceWorker.register('service-worker.js').then((serviceWorkerRegistration) => {
          let toastCtrl = this.toastCtrl;
          console.log('USe service worker');
          this.messaging.useServiceWorker(serviceWorkerRegistration);
          //requestPermission
          this.messaging.requestPermission().then(() => {

            console.log('Notification permission granted.');
          }, error => {
            console.log(error);
            if (error.code == 'messaging/permission-blocked') {
              let toast = toastCtrl.create({
                message: 'El navegador o el usuario negaron el permiso para notificaciones',
                duration: 3000
              });
              toast.present();
            } else {
              let toast = toastCtrl.create({
                message: error.message,
                duration: 5000
              });
              toast.present();
            }
          });
        }).catch(err => console.error('Error', err));
     */
    /*
      Handle Web Notifications when Ayo is Active
    */
    this.messaging.onMessage(payload => {
      this.response = (payload as any);
      console.log('onMessage: ', this.response.notification);
      let toast = toastCtrl.create({
        message: this.response.notification.body,
        duration: 3000
      });
      toast.present();
    });
    // }
  }

  public async sendNotification(tokens, title, body, action) {
    console.log('notificacion')
    let newNotif = {
      "to": tokens,
      "notification": {
        "title": title,
        "body": body,
        "click_action": action,
        "icon": "https://firebasestorage.googleapis.com/v0/b/orion-6d6cd.appspot.com/o/asistco-icon.png?alt=media&token=c221bf53-348c-4981-9788-56ef4d494ce0"
      }
    };

    await this.httpProv.post('https://fcm.googleapis.com/fcm/send', JSON.stringify(newNotif), this.httpOptions).subscribe(
      function (response) {
        this.httpResponse = response;/*
        console.log('Response', this.httpResponse); */

      },
      function (error) {
        console.log("Error happened" + error)
      },
      function (this) {
        this.httpResponse['body'];
      }
    );
  }


  /*
   	Get device web token
  */
  public getToken() {
    return this.messaging.getToken();
  }

  /*
   	Request permission
  */
  public requestPermission() {
    return this.messaging.requestPermission();
  }


}



// WEBPACK FOOTER //
// ./src/providers/notification-web/notification-web.ts